import React, { createContext, useContext, useState, useEffect } from 'react';
import API from '../api/axios';
import toast from 'react-hot-toast';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('numToken');
        const userData = localStorage.getItem('numUser');
        if (token && userData) {
            setUser(JSON.parse(userData));
        }
        setLoading(false);
    }, []);

    const _saveUser = (userData) => {
        localStorage.setItem('numUser', JSON.stringify(userData));
        setUser(userData);
    };

    const login = async (email, password) => {
        const res = await API.post('/auth/login', { email, password });
        localStorage.setItem('numToken', res.data.token);
        _saveUser(res.data.user);
        toast.success(`Welcome back, ${res.data.user.firstName}! 🔢`);
        return res.data.user;
    };

    const register = async (formData) => {
        const res = await API.post('/auth/register', formData);
        localStorage.setItem('numToken', res.data.token);
        _saveUser(res.data.user);
        toast.success('Account created successfully! ✨');
        return res.data.user;
    };

    const logout = () => {
        localStorage.removeItem('numToken');
        localStorage.removeItem('numUser');
        setUser(null);
        toast.success('Logged out successfully');
    };

    // Call this after a successful payment to refresh subscription status
    const refreshSubscription = async () => {
        try {
            const res = await API.get('/payment/status');
            if (res.data.success) {
                const updated = { ...user, subscription: res.data.subscription };
                _saveUser(updated);
                return updated;
            }
        } catch (err) {
            console.error('Failed to refresh subscription:', err);
        }
    };

    // Check if current user is subscribed (admin always passes)
    const isSubscribed = () => {
        if (!user) return false;
        if (user.role === 'admin') return true;
        return user?.subscription?.active === true;
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, register, logout, refreshSubscription, isSubscribed }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
